var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('h1',[_vm._v(" All Transactions ")]),_c('v-spacer'),_c('back-to-dashboard')],1),_c('v-row'),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.transactions,"elevation":2},scopedSlots:_vm._u([{key:"item.category",fn:function(ref){
var item = ref.item;
return [_c('category-chip',{attrs:{"name":item.category}})]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('edit-transaction-dialog',{attrs:{"id":item._id}})]}},{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(new Date(item.timestamp).toLocaleString())+" ")]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }